import * as gs from "@ivanlog/gs";
import { CmpTableItemLPX, CmpWidgetLPXTableBase } from "./tmpls";
import { LPXInfrastructure } from "../contracts/LPXInfrastructure";
import { App } from "../App";
import { Web3Helper } from "../libs/Web3Helper";
import { BiMath } from "../libs/BiMath";
import { CmpWidgetLPXDetails } from "./CmpWidgetLPXDetails";
import { LPXConfig } from "../contracts/LPXContract";

export class CmpWidgetLPXTable extends CmpWidgetLPXTableBase {

    private _lpxInf:LPXInfrastructure;
    private _cmpDetails:CmpWidgetLPXDetails;
    private _selectedPoolId:number;
    private _items:CmpTableItemLPX[]=[];
    constructor() {
        super();
        this.disable();
        this.ctrls.btnConnect.onclick=async ()=>{
            this.ctrls.btnConnect.disable();
            const result = await App.chain.tryConnectAsync();
            this.ctrls.btnConnect.enable();
        }
    }

    public async refreshAsync(cmpDetails:CmpWidgetLPXDetails)
    {
        this._cmpDetails=cmpDetails;
        const lpxInf = App.Inst.getInst(LPXInfrastructure);
        this._lpxInf=lpxInf;

        let takePools = parseInt(await lpxInf.lpx.lastPoolId());
        if (takePools>50) takePools=50; //TODO pagination
        const poolIds=[];
        for(let i=1;i<=takePools;i++)
        { 
            if (i==6) continue; //Прячем пустые 3 пула 
            if (i==7) continue;
            if (i==25) continue;
            poolIds.push(i);
        }

        const account = App.chain.account;

        const pools = await lpxInf.lpx.getPoolsByIds(poolIds);
        const addresses = [...pools.configs_.map(c=>lpxInf.pAdrToAdr(c.fundToken)),...pools.configs_.map(c=>lpxInf.pAdrToAdr(c.anchorToken))];
        
        const symbols = await lpxInf.getSymbolsAsync(addresses);
        for(const item of this._items) item.cut();
        gs.array.clear(this._items);
        let firstActive = false;
        for(let i=0;i<pools.reserves_.length;i++)
        {
            const config = pools.configs_[i];
            const reserve = pools.reserves_[i];
            const fundAdr = lpxInf.pAdrToAdr(config.fundToken);
            const anchorAdr = lpxInf.pAdrToAdr(config.anchorToken);
            
            //skip solo contract if manager!=account
            if (lpxInf.hasFlag(config.pack, LPXInfrastructure.PACKFLAG_MANAGER_ONLY))
            {
                if (!account) continue;
                if (config.manager.toLowerCase()!=account.toLocaleLowerCase() &&
                    account.toLocaleLowerCase()!=LPXInfrastructure.ADDRESS_DEBUG.toLocaleLowerCase())
                    continue;
            }

            const item = new CmpTableItemLPX();
            item.ctrls.lSymbols.text = symbols.get(fundAdr)+"/"+symbols.get(anchorAdr)
            item.ctrls.lReserveFund.text = Web3Helper.ToLargeNumberUnit(reserve.fundReserve*this._lpxInf.getDecimalCorIndex(fundAdr)/BiMath.Decimal);
            item.ctrls.lReserveAnchor.text = Web3Helper.ToLargeNumberUnit(reserve.anchorReserve*this._lpxInf.getDecimalCorIndex(anchorAdr)/BiMath.Decimal);
            this.ctrls.list.append(item);
            this._items.push(item);

            item.onclick=async()=>{
                for(const i of this._items) i.inactive();
                item.active();
                try
                {
                    this.ctrls.list.disable();
                    this._selectedPoolId=poolIds[i];
                    await this._cmpDetails.refreshAsync(poolIds[i], config, reserve);
                } catch(ex)
                {
                    console.error(ex);
                }
                this.ctrls.list.enable();
            }
            if (!firstActive&&!this._selectedPoolId){
                firstActive=true;
                item.el.click();
            }
            if (this._selectedPoolId==poolIds[i]) item.el.click();
        }

        this.enable();

        this.ctrls.blockConnect.show();
        if (App.chain.account) 
        {
            this.ctrls.blockConnect.hide();
      //      this._cmpDetails.refreshAsync(pools.configs_[0]);
        }
    }


}